export const PZ_SEKMELER = ['genel', 'kampanya', 'geri-kazanim', 'riza', 'seo', 'ai'] as const;
export const SEO_SEKMELER = ['kpi', 'hedef', 'kelime', 'dizin', 'baglar', 'takvim', 'yazi', 'arama'] as const;
export type PzSekme = typeof PZ_SEKMELER[number];
export type SeoAlt = typeof SEO_SEKMELER[number];
export function pazarlamaDurumu() {
  const p = new URLSearchParams(window.location.search);
  return {
    sekme: p.get('alt') === 'ai' ? 'ai' as const : PZ_SEKMELER.find((s) => s === p.get('sekme')) ?? 'genel',
    alt: SEO_SEKMELER.find((s) => s === p.get('alt')) ?? 'kpi',
  };
}
export function pazarlamaAdres(sekme: PzSekme, alt: SeoAlt) {
  const url = new URL(window.location.href);
  url.searchParams.set('sekme', sekme);
  if (sekme === 'seo') url.searchParams.set('alt', alt);
  else url.searchParams.delete('alt');
  const hedef = `${url.pathname}${url.search}${url.hash}`;
  if (hedef === `${window.location.pathname}${window.location.search}${window.location.hash}`) return;
  window.history.replaceState(window.history.state, '', hedef);
  window.dispatchEvent(new Event('crm:pazarlama'));
}

export const PZ_IZIN: Record<PzSekme, readonly string[]> = {
  genel: [],
  kampanya: ['marketing:campaign:read'],
  'geri-kazanim': ['marketing:campaign:read'],
  riza: ['marketing:consent:read', 'marketing:log:read', 'newsletter:read', 'marketing:segment'],
  seo: ['marketing:seo:read'],
  ai: ['marketing:seo:read'],
};
export function sekmeGorunur(sekme: PzSekme, izinler: readonly string[]) {
  const gereken = PZ_IZIN[sekme];
  return gereken.length === 0 || gereken.some((izin) => izinler.includes(izin));
}
